export const mediaQuery = (bp: string | number) => {
  let breakP = bp;
  if (typeof bp === "number") {
    breakP = `${bp}px`;
  }
  return `@media (min-width: ${breakP})`;
};
